<template>
    <FormSection
        title="Admission Source and Timing (PDGM)"
        type="his-section"
        :full-height="false"
        :application-id="Number(application)"
    >
        <template v-slot:content>
            <section class="row py-3 g-0">
                <div class="col-12 col-lg-12 px-4 col-md-12 g-0">
                    <p class="mb-2 d-flex align-items-center">
                        <b>Emergency Triage</b>
                    </p>
                    <div v-for="option of emergencyTriageOptions" class="form-check custom-radio pb-1">
                        <input
                            type="radio"
                            class="form-check-input"
                            :id="`${option.value}-${option.label}`"
                            :value="option.value"
                            :checked="option.value === referral.EmergencyPreparedness.Triage"
                            v-model="referral.EmergencyPreparedness.Triage"
                        />
                        <label class="form-check-label mb-2" :for="`${option.value}-${option.label}`">
                            <small>{{ option.label }}</small></label
                        >
                    </div>
                </div>
                <div class="col-12 col-lg-12 px-4 col-md-12 g-0">
                    <p class="mb-2 d-flex align-items-center">
                        <b>Additional Emergency Preparedness Information</b>
                    </p>
                    <div v-for="option of Object.values(additionalInformationOptionsEnum)">
                        <div class="form-check custom-checkbox pb-1">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                :id="`${option.value}-${option.label}`"
                                :value="option.value"
                                :checked="isAddInformationOptions(option.value)"
                                @change="handleAddInformationOptions(option.value)"
                            />
                            <label class="form-check-label" :for="`${option.value}-${option.label}`">
                                <small>{{ option.label }} </small>
                            </label>
                        </div>
                    </div>
                    <template v-if="isAddInformationOptions('3')">
                        <div class="d-flex bg-white flex-column ms-4 w-90 pb-4">
                            <label class="service-required-text-color"
                                >Medical Needs/Equipment: ({{ fetchMedicalNeedsCharLeft }} characters left)</label
                            >
                            <input
                                type="text"
                                class="form-control w-90"
                                placeholder="Enter Admission Source"
                                v-model="referral.EmergencyPreparedness.MedicalNeeds"
                                maxlength="2000"
                            />
                        </div>
                    </template>
                </div>
            </section> </template
    ></FormSection>
</template>

<script lang="ts" src="./EmergencyTriage.ts"></script>
